import { Component, OnInit } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { element } from 'protractor';
import {  Constants } from 'src/app/data-model/constant.model';

@Component({
  selector: 'app-base-page',
  templateUrl: './base-page.page.html',
  styleUrls: ['./base-page.page.scss'],
})
export class BasePagePage {

  // public isLoading: boolean = false;

  public static alertPresented: any;
  public static alertController: AlertController

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
  ) {
    BasePagePage.alertController = this.alertCtrl;
  }

  /*
  presentLoading() {
    // Dismiss all pending loaders before creating the new one
    // this.dismissLoading();

    this.loadingCtrl.create().then(res => {
      res.present();
    });
    
  }

  async dismissLoading() {
    if (this.loadingCtrl.getTop() && this.loadingCtrl.getTop()['__zone_symbol__value'] && this.loadingCtrl.getTop()['__zone_symbol__value'] !== undefined) {
      await this.loadingCtrl.dismiss();
    }
  }

  presentLoading() {

    var action: Promise<any>;
    if (this.isLoading === false) {
      action = this.loadingCtrl.create({
        // duration: 5000,
      }).then(a => {
        a.present().then(() => {
          console.log('presented');
          if (!this.isLoading) {
            a.dismiss().then(() => console.log('abort presenting'));
          }
        }).finally(() => {
          this.isLoading = true;
        });
      })
    } else {
      action = null;
    }

    return action;

  }

  async dismissLoading(): Promise<any> {

    var action: Promise<any>;
    if (this.isLoading === true && this.loadingCtrl.getTop()['__zone_symbol__value'] !== undefined) {
      action = this.loadingCtrl.dismiss().then(() => console.log('dismissed')).finally(()=> {
        this.isLoading = false;
      })
    } else {
      action = null;
    }

    return await action;

  }
  */

  public static async presentAlert(header: string, message: string, callback?: (response: any) => void, buttons?: Array<any>, input?: Array<any>) {

    // if (BasePagePage.alertController.getTop()['__zone_symbol__value']) {
    //   BasePagePage.alertController.dismiss();
    // }

    let vm = this
    if (!vm.alertPresented) {
      vm.alertPresented = true
      var arrButton = buttons;

      if (arrButton == null || arrButton.length == 0) {
        arrButton = [{ text: Constants.b_OK, role: Constants.b_OK }]
      } else {
        var arrVerified: Array<any> = [];
        arrButton.forEach(element => {
          if (element.text || element.role) {
            arrVerified.push(element);
          } else {
            let strElement = element.toString();
            arrVerified.push({ text: strElement, role: strElement });
          }
        });
        arrButton = arrVerified;
      }
      const alert = await BasePagePage.alertController.create({
        header: header,
        inputs: input,
        subHeader: '',
        message: message,
        buttons: arrButton,
        backdropDismiss: false
      });
      await alert.present();
      await alert.onDidDismiss().then((res) => {
        // console.log('resssss alert: ', res);
        vm.alertPresented = false
        if (res.role && (res.role.toString() != Constants.b_CANCEL) && callback) {
          callback(res);
        }
      });
      // console.log(header, "\t\t\t", message, "\t\t\t", result);
    }

  }

}
